export default __webpack_public_path__ + "static/banner_home_3-012b7da5e817fcf27865ed1d9c0dd583.jpg";